/**
 * Convertit une image base64 en objet File
 * @param {string} base64String - Image en base64 (avec ou sans préfixe data:image/...)
 * @param {string} fileName - Nom du fichier de sortie
 * @returns {File} Objet File prêt pour l'upload
 */
export const base64ToFile = (base64String, fileName = "image.jpg") => {
  // Extraire le type MIME et les données base64
  const arr = base64String.split(",")
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/jpeg"
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], fileName, { type: mime })
}

/**
 * Convertit une image base64 en Blob
 * @param {string} base64String - Image en base64
 * @returns {Blob} Objet Blob
 */
export const base64ToBlob = (base64String) => {
  const arr = base64String.split(",")
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/jpeg"
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new Blob([u8arr], { type: mime })
}

/**
 * Convertit une image base64 en File avec blob URL temporaire
 * @param {string} base64String - Image en base64
 * @param {string} fileName - Nom du fichier
 * @returns {{ file: File, blobUrl: string }} File + URL blob temporaire
 */
export const base64ToFileWithBlobUrl = (base64String, fileName = "image.jpg") => {
  const file = base64ToFile(base64String, fileName)
  const blobUrl = URL.createObjectURL(file)

  return {
    file,
    blobUrl,
  }
}

/**
 * Révoque un blob URL pour libérer la mémoire
 * @param {string} blobUrl - URL blob à révoquer
 */
export const revokeBlobUrl = (blobUrl) => {
  if (blobUrl && blobUrl.startsWith("blob:")) {
    URL.revokeObjectURL(blobUrl)
  }
}
